import { reactive } from 'vue';

export interface Toast {
    id: number;
    message: string;
    type: 'error' | 'success' | 'warning';
}

const toasts = reactive<Toast[]>([]);
let nextId = 0;

export function useToast() {
    function show(message: string, type: Toast['type'] = 'error', duration = 5000) {
        const id = nextId++;
        toasts.push({ id, message, type });
        setTimeout(() => remove(id), duration);
    }

    function remove(id: number) {
        const index = toasts.findIndex((t) => t.id === id);
        if (index !== -1) toasts.splice(index, 1);
    }

    return { toasts, show, remove };
}
